import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/constants/testIds";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=85&auto=format&fit=crop";

export const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 border-b border-neutral-900 relative">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Left image */}
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] overflow-hidden border border-neutral-800">
            <img
              src={ABOUT_IMG}
              alt="Endüstriyel mühendislik"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-[#ff5a00] text-black p-6 max-w-[240px]">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.3em] mb-2">
              Est. 2012
            </div>
            <div className="font-display font-bold text-xl tracking-tight">
              14+ Yıllık Sektörel Deneyim
            </div>
          </div>
        </div>

        {/* Right content */}
        <div className="lg:col-span-6 lg:pl-6">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-6 h-px bg-[#ff5a00]" />
            <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#ff5a00]">
              Hakkımızda / 02
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
            Biz kimiz?
          </h2>
          <div className="mt-8 space-y-6 text-neutral-300 leading-relaxed max-w-xl">
            <p>
              <span className="text-white font-medium">MoDuLerİS</span>, enerjinin gücünü ve mimarinin estetiğini{" "}
              <em className="text-[#ff5a00] not-italic font-medium">modüler mühendislik</em>{" "}
              felsefesiyle harmanlayan İzmir merkezli yenilikçi bir kuruluştur.
            </p>
            <p className="text-neutral-400 text-sm md:text-base">
              2012'den bu yana; sürdürülebilir enerjiyi estetik tasarımlarla buluşturuyor, karmaşık
              elektrik ve altyapı projelerini yüksek standartlarda hayata geçiriyoruz. Biz sadece
              proje üretmiyor, geleceğin akıllı ve çevre dostu yapı taşlarını örüyoruz.
            </p>
          </div>

          {/* Leader spotlight */}
          <div className="mt-10 border border-neutral-800 bg-[#0d0d0e] p-6 md:p-7 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-24 h-24 bg-[#ff5a00]/10 blur-3xl pointer-events-none" />
            <div className="flex items-start gap-4">
              <span className="mt-1 w-10 h-10 flex items-center justify-center border border-[#ff5a00]/40 text-[#ff5a00] font-display font-semibold text-lg">
                SE
              </span>
              <div>
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.28em] text-[#ff5a00] mb-2">
                  Kurucu · Yönetici
                </div>
                <div className="font-display text-lg md:text-xl font-semibold text-white tracking-tight">
                  Selvihan Erdönmez
                </div>
                <p className="text-neutral-400 text-sm mt-2 leading-relaxed max-w-md">
                  Şirketimiz, 2016'dan bu yana elektrik sektöründe sahada aktif olarak çalışan bir
                  kadın yönetici tarafından yönetiliyor. Teknik uzmanlık ve saha tecrübesini bir
                  araya getiren liderlik anlayışıyla, her projede aynı titizliği koruyoruz.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-lg border-t border-neutral-900 pt-8">
            <div>
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-1">
                Vizyon
              </div>
              <div className="font-display text-sm md:text-base text-white">Sürdürülebilir</div>
            </div>
            <div>
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-1">
                Yaklaşım
              </div>
              <div className="font-display text-sm md:text-base text-white">Modüler</div>
            </div>
            <div>
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-1">
                Standart
              </div>
              <div className="font-display text-sm md:text-base text-white">Anahtar Teslim</div>
            </div>
          </div>

          <a
            data-testid={SITE.aboutButton}
            href="#services"
            className="mt-10 inline-flex items-center gap-2 text-white group text-sm uppercase tracking-[0.2em] border-b border-neutral-700 hover:border-[#ff5a00] hover:text-[#ff5a00] transition-colors pb-2"
          >
            Kurumsal Hikayemiz
            <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
